<template>
  <div>
    <h1 class="page-header">
      {{ $t('vehicleProfile.vehicleProfile') }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div>
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'vehicle-profile-create' })"
              >{{ $t('add_new') }}</ts-button
            >
            <ts-button class="ml-2" @click.prevent="showFormCopy">
              {{ $t('school.payment.setup.feeSetup.copyFee') }}
            </ts-button>
          </div>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'branch.branch_name_en'
          }"
        >
          <template v-slot="{ record }">
            <td>{{ record.car_number }}</td>
            <td>{{ record.plate_no }}</td>
            <td>{{ record.model }}</td>
            <td>{{ record.engine_no }}</td>
            <td>{{ record.frame_no }}</td>
            <td>{{ record.color }}</td>
            <td>{{ record.powercc }}</td>
            <td>{{ record.seat_no }}</td>
            <td>{{ record.max_student }}</td>
            <td>{{ record.price }}</td>
            <td>{{ record.register_date }}</td>
            <td>{{ record.date_purchasing }}</td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="'Edit'"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="'Delete'"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-drawer
        :title="$t('invoice.filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        width="300px"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <a-select
                style="width: 257px"
                v-model="branch_id"
                :options="branchs"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
          </div>
        </div>
      </a-drawer>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'vehicle-profile',
  data () {
    return {
      loading: false,
      visible: false,
      branchs: [],
      columns: [
        { name: this.$t('vehicleProfile.cardNo'), sortKey: 'car_number' },
        { name: this.$t('vehicleProfile.plateNo'), sortKey: 'plate_no' },
        { name: this.$t('vehicleProfile.model'), sortKey: 'model' },
        { name: this.$t('vehicleProfile.engine'), sortKey: 'engine_no' },
        { name: this.$t('vehicleProfile.framNo'), sortKey: 'frame_no' },
        { name: this.$t('vehicleProfile.color'), sortKey: 'color' },
        { name: this.$t('vehicleProfile.powerCC'), sortKey: 'powercc' },
        { name: this.$t('vehicleProfile.seat'), sortKey: 'seat_no' },
        { name: this.$t('vehicleProfile.maxStudent'), sortKey: 'max_student' },
        { name: this.$t('vehicleProfile.price'), sortKey: 'price' },
        { name: this.$t('vehicleProfile.registerDate'), sortKey: 'register_date' },
        { name: this.$t('vehicleProfile.purchasingDate'), sortKey: 'date_purchasing' },
        { name: this.$t('vehicleProfile.actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('vehicleProfile', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.vehicleProfile.search
      },
      set (newValue) {
        this.$store.commit('vehicleProfile/SET_SEARCH', newValue)
        this.$store.commit('vehicleProfile/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.vehicleProfile.branch_id
      },
      set (newValue) {
        this.$store.commit('vehicleProfile/SET_BRANCH_ID', newValue)
      }
    }
  },
  methods: {
    fetchData (attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'vehicleProfile/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit (record) {
      this.$store.commit('vehicleProfile/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'vehicle-profile-edit',
        params: { id: record.vehicle_id }
      })
    },

    async destroy (record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('vehicleProfile/destroy', record.vehicle_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('vehicleProfile/RESET_STATE')
    }
    next()
  }
}
</script>
